export default __webpack_public_path__ + "static/media/J_sound.b4ee9863.mp3";